import React, { Fragment, useContext, useEffect, useState } from 'react'
import { Page, Site, CollectionPage, TablePage, Icon } from 'ywana-core8'
import { AppContext, AppContextProvider } from "./AppContext";
import Login from './pages/login/page'
import Projects from './pages/projects/page'
import Environments from './pages/environments/page'
import Users from './pages/users/page'
import Teams from './pages/teams/page'
import Clients from './pages/clients/page'
import Calendar from './pages/calendar/page'
import './css/theme_light.css'

/**
 * Site
 */
const AppSite = () => {
    const init = "PROJECTS";


    const actions = [
        { icon: "done", action: () => { alert('PLAY')}},
        { icon: "stop", action: () => { alert('STOP')}},
        { icon: "message", action: () => { alert('MESSAGE')}},
    ]

    return (
        <Site icon="hub" title={`Ywana Workspace`} init={init} min >

            <Page id="CALENDAR" section="App" icon="date_range" title="Calendar" layout="workspace">
                <Calendar />
            </Page>

            <Page id="PROJECTS" section="App" icon="folder_special" title="Projects" layout="workspace">
                <Projects />
            </Page>

            <Page id="ENVIRONMENTS" section="App" icon="microwave" title="Environemnts" layout="workspace">
                <Environments />
            </Page>

            <Page id="Clients" section="App" icon="hail" title="Clients" layout="workspace">
                <Clients />
            </Page>

            <Page id="TEAMS" section="App" icon="people" title="Teams" layout="workspace">
                <Teams />
            </Page>

            <Page id="USERS" section="App" icon="person" title="Projects" layout="workspace">
                <Users />
            </Page>

            <Page id="LOGIN" section="App" icon="meeting_room" title="Salida" layout="overall">
                <Login />
            </Page>

        </Site>
    );
};

/**
 * App
 */
const App = (props) => {
    return (
        <AppContextProvider>
            <AppSite />
        </AppContextProvider>);
};

export default App;
